<template>
  <div :class="classes">
    <package-option
      v-for="(packageOption, poIndex) in packageOptions"
      :key="poIndex"
      :package-option="packageOption"
      :package-option-index="poIndex"
    />
    <!-- not yet implemented -->
    <h5
      v-if="false"
      class="package-option__sub-header package-option__sub-header--alt-gradimages hidden-lg"
    >@BrandInvariant.OptionsAppliedPerImage</h5>
  </div>
</template>

<script>
import PackageOption from './PackageOption.vue'

export default {
  name: 'PackageOptions',
  components: {
    PackageOption
  },
  computed: {
    packageOptions () {
      return this.$store.state.optionProducts.packageOptionsModel.ListableOptions
    },
    classes () {
      return {
        'package-options': true,
        'package-options--none': this.packageOptions.length === 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.package-options {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/PackageOptions.vue